import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  LearmoModalRef,
  LearmoModalService,
} from 'src/app/shared/services/learmo-modal.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { BillingLogItem } from 'src/app/models/billing-log';

@Component({
  selector: 'app-transaction-info-popup',
  templateUrl: './transaction-info-popup.component.html',
  styleUrls: ['./transaction-info-popup.component.css'],
})
export class TransactionInfoPopupComponent implements OnInit {
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @Input() modalOpener: EventEmitter<any>;

  @Input() transaction: BillingLogItem;

  @Output() onModalEvent: EventEmitter<any> = new EventEmitter<any>();

  modalRef: LearmoModalRef;
  modalOpenerSubscription: Subscription;
  isOpen: boolean = false;
  constructor(
    private modalService: LearmoModalService,
    private router: Router,
    private toastr: ToastrService
  ) {}
  ngOnDestroy(): void {
    // this.modalOpenerSubscription.unsubscribe();
  }

  ngOnInit(): void {}

  async onOpenModal() {
    this.resetEverything();

    // this.resetForm();
    // this.productObject.type_id = 1;
  }

  closeModal() {
    this.modalRef.close();

    this.onModalEvent.emit('close');
  }
  resetEverything() {}

  onStartTour() {
    this.onModalEvent.emit('startTour');
    this.modalRef.close();
  }

  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      title: 'Invoice',
      size: 'lg',
      premium: true,
      transparent: true, // Custom invoice look
    });
    this.isOpen = true;

    // Result handling might differ slightly with ref, but basic promise usually works if we cared about result.
    // For now we just track isOpen via open/close.
  }
}
